module.exports = __webpack_public_path__ + "static/img/logo.b9a5061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 23